import { createSlice } from '@reduxjs/toolkit';
import {
  CareerEducationDetailsType,
  CareerEmploymentHistory,
  CareerErrorType,
  CareerType,
} from '../../Types/careers';

export interface CareerState {
  career: CareerType;
  careerErrors: CareerErrorType;
}

const defaultEducationDetails: CareerEducationDetailsType = {
  highest_degree: '',
  last_school: '',
};

const defaultCareerEmploymentHistory: CareerEmploymentHistory = {
  company_name: '',
  last_role: '',
  supervisor_name: '',
  country: '',
  city: '',
  state: '',
  street: '',
  zip: '',
  start_date: '',
  end_date: '',
  experience_summary: '',
  reason_of_leaving: '',
};

const defaultCareerValue: CareerType = {
  personal_details: {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    street_address: '',
    country: '',
    city: '',
    state: '',
    zip: '',
    country_code: 'US', // default to US to match PhoneInput
  },
  job_details: {
    position_applied: '',
    availability: '',
    position_type: '',
    extra_hours_availability: false,
    job_eligibility: false,
    age_eligibility: false,
    roles_eligibility: false,
    non_eligibility_of_job_roles: '',
    skills_eligibility: '',
    other_language_eligibility: false,
    other_language: '',
  },
  education_details: [defaultEducationDetails],
  employment_history: [
    defaultCareerEmploymentHistory,
    // defaultCareerEmploymentHistory,
    // defaultCareerEmploymentHistory,
    // defaultCareerEmploymentHistory,
  ],
  driving_license_details: {
    state_and_current_license_number: '',
    license_operators: '',
    any_license_denied: false,
    any_license_suspension: false,
    docs_details_of_any_suspension: '',
  },
  acceptance_consent: {
    first_name: '',
    last_name: '',
    date: '',
  },
  consent_drug_test: {
    first_name: '',
    last_name: '',
    date: '',
  },
  recaptcha_token: '',
};

const initialState: CareerState = {
  career: defaultCareerValue,
  careerErrors: defaultCareerValue,
};

const careersSlice = createSlice({
  name: 'careersSlice',
  initialState,
  reducers: {
    setCareersData: (state, action: { payload: CareerType }) => {
      state.career = {
        ...state.career,
        ...action.payload,
      };
    },
    resetCareersData: (state) => {
      state.career = defaultCareerValue;
    },
    updateCareerPersonalDetails: (
      state,
      action: { payload: Partial<typeof defaultCareerValue.personal_details> }
    ) => {
      state.career.personal_details = {
        ...state.career.personal_details,
        ...action.payload,
      };
      // clear errors for the updated fields
      Object.keys(action.payload).forEach((key) => {
        state.careerErrors.personal_details = {
          ...state.careerErrors.personal_details,
          [key]: '',
        };
      });
    },
    updateCareerErrors: (state, action: { payload: CareerErrorType }) => {
      state.careerErrors = {
        ...action.payload,
      };
    },
  },
});

export const {
  setCareersData,
  resetCareersData,
  updateCareerErrors,
  updateCareerPersonalDetails,
} = careersSlice.actions;
export default careersSlice.reducer;
